<script>
import PartnerObject from '@/components/page-partners/PartnerObject.vue';
import PartnerAdd from '@/components/page-partners/PartnerAdd.vue';

export default {
    name: 'PartnerList',

    components: {
        PartnerObject,
        PartnerAdd,
    },

    data() {
        return {
            showAddForm: false,
        };
    },

    computed: {
        partners() {
            return this.$store.getters.PARTNERS;
        },
        isLoading() {
            return this.$store.getters.IS_PARTNERS_LOADING;
        },
    },

    methods: {
        onAdded() {
            this.showAddForm = false;
        },
        onCancel() {
            this.showAddForm = false;
        },
    },
};
</script>

<template>
    <div class="partner-list">
        <!-- Header -->
        <div class="list-header">
            <h2 class="list-title">Partners</h2>
            <button
                v-if="!showAddForm"
                class="btn-add"
                @click="showAddForm = true"
            >
                + Add Partner
            </button>
        </div>

        <!-- Add form (collapsible) -->
        <div v-if="showAddForm" class="add-form-wrapper">
            <PartnerAdd @added="onAdded" @cancel="onCancel" />
        </div>

        <!-- Loading -->
        <div v-if="isLoading" class="loading-text">Loading partners…</div>

        <!-- Empty -->
        <div v-else-if="partners.length === 0 && !showAddForm" class="empty-state">
            <p class="empty-text">No partners yet.</p>
            <button class="btn-add" @click="showAddForm = true">+ Add first partner</button>
        </div>

        <!-- Table -->
        <div v-else-if="partners.length > 0" class="partner-table">
            <!-- Column headers -->
            <div class="table-header">
                <div class="th th--name">Name / Code</div>
                <div class="th th--type">Source type</div>
                <div class="th th--status">Status</div>
                <div class="th th--actions">Actions</div>
            </div>
            <PartnerObject
                v-for="partner in partners"
                :key="partner.id"
                :partner="partner"
            />
        </div>
    </div>
</template>

<style scoped>
.partner-list {
    padding: 0;
}
.list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0 14px;
    border-bottom: 2px solid #f1f5f9;
    margin-bottom: 16px;
}
.list-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
}
.btn-add {
    background: #10b981;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 7px 16px;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s;
    white-space: nowrap;
}
.btn-add:hover {
    background: #059669;
}
.btn-add--active {
    background: #64748b;
}
.btn-add--active:hover {
    background: #475569;
}
.add-form-wrapper {
    border: 1px solid #dbeafe;
    border-radius: 8px;
    background: #f8faff;
    padding: 20px;
    margin-bottom: 20px;
}
.table-header {
    display: grid;
    grid-template-columns: 1fr 140px 100px auto;
    gap: 12px;
    padding: 6px 16px;
    margin-bottom: 6px;
}
.th {
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #94a3b8;
}
.th--actions {
    text-align: right;
    min-width: 200px;
}
.empty-state {
    text-align: center;
    padding: 40px 20px;
    color: #94a3b8;
}
.empty-text {
    margin-bottom: 12px;
    font-size: 0.9rem;
}
</style>
